import { useEffect, useState } from "react";
import axios from "axios";
import { parse } from "tldts";

// ✅ Utility to build a valid full image URL
const getImageUrl = (path) => {
  if (!path) return "";
  const cleanPath = path.startsWith("images/") ? path.slice(7) : path;
  return `https://payyug.in/${cleanPath}`;
};

// ✅ Get clean domain and subdomain info
const getDomainInfo = () => {
  const hostname = window.location.hostname.replace(/^www\./, "");
  const parsed = parse(hostname);

  // your backend stores domain WITHOUT suffix (e.g. pavitrammfi)
  const domainWithoutSuffix =
    parsed.domainWithoutSuffix || hostname.split(".")[0];

  const subdomain = parsed.subdomain || "";
  return { domain: domainWithoutSuffix, subdomain };
};

export const useCompanyBranding = () => {
  const [company, setCompany] = useState({
    name: "",
    logo: null,
    favicon: null,
    domain: "",
    subdomain: "",
  });
  const [fetchError, setFetchError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const { domain, subdomain } = getDomainInfo();
        console.log("🌐 Full Hostname:", window.location.hostname);
        console.log("🔍 Parsed Domain Info →", { domain, subdomain });

        const response = await axios.get("https://payyug.in/api/get-company", {
          params: { domain },
        });

        console.log("📦 Full API Response:", response);
        const data = response.data;
        console.log("📊 Parsed Company Data:", data);

        if (data && Object.keys(data).length > 0) {
          setCompany({
            name: data.name || "",
            logo: data.logo || null,
            favicon: data.favicon || null,
            domain: data.domain || "",
            subdomain: data.subdomain || "",
          });

          console.log("🏢 Company State Updated:", {
            name: data.name,
            logo: data.logo,
            favicon: data.favicon,
            domain: data.domain,
            subdomain: data.subdomain,
          });

          // ✅ Update favicon
          if (data.favicon) {
            let link =
              document.querySelector("link[rel='icon']") ||
              document.createElement("link");
            link.type = "image/png";
            link.rel = "icon";
            link.href = getImageUrl(data.favicon);
            document.head.appendChild(link);
            console.log("🖼️ Favicon updated:", link.href);
          }

          // ✅ Update title
          if (data.name) {
            document.title = `${data.name}`;
            console.log("✅ Title updated:", document.title);
          }
        } else {
          console.warn("⚠️ Company info not found for domain:", domain);
          setFetchError("Company info not found.");
          document.title = "pavitrammfi";
        }
      } catch (err) {
        console.error("❌ Failed to fetch company info:", err);
        setFetchError("Failed to fetch company info");
        document.title = "pavitrammfi";
      } finally {
        setLoading(false);
        console.log("⏳ Fetch completed, loading state:", false);
      }
    };

    fetchCompany();
  }, []);

  return { company, fetchError, loading };
};



